import * as login from '@/util/login'
/* 后台接口返回状态码 */
export const Success = 200; // 调用成功
export const Forbidden = 403; // 没有权限访问
export const Unauthorized = 401; // 未登录
export const Server_Error = 500; // 服务器错误
export const Business_Error = 501; // 不满足业务逻辑
export const Server_busy = 502; // 不满足业务逻辑
export const Order_Error = 505; // 下单失败
export const Bad_Request = 400; // 参数错误
/* 判断调用是否成功*/
export function isSuccess(res) {
	return res.data.status.code == Success
}
/* 判断是否没有权限调用 */
export function isForbidden(res) {
	return res.data.status.code == Forbidden
}
/* 判断是否未登录 */
export function isUnauthorized(res) {
	return res.data.status.code == Unauthorized
}
/* 判断是否服务器发生异常 */
export function isError(res) {
	return res.data.status.code == Server_Error
}
/* 判断是否不满足业务逻辑 */
export function isBusinessError(res) {
	return res.data.status.code == Business_Error
}
/* 判断是否参数存在问题异常 */
export function isBadRequest(res) {
	return res.data.status.code == Bad_Request
}
/* 判断是否是下单错误 */
export function isBadOrder(res) {
	return res.data.status.code == Order_Error
}
/* 判断是否多次点击 */
export function isServerBusy(res) {
	return res.data.status.code == Server_busy
}
/*
方法名：获取数据集
参数：res，http请求返回数据
	  object,页面的this对象，用于调用object.$Message.error打印错误信息，可不传
返回值：请求成功返回结果集
        请求失败，返回false
*/
export function data(res, object, callback) {
	if (isSuccess(res)) {
		var data = res.data.data;
		if (data instanceof Object) {
			data.currentDate = res.headers.date;
		}
		return data;
	} else if (isUnauthorized(res)) {
		/* to login*/
		login.redirectToLogin();
	} else if (isError(res)) {
		if (object) {
			if (res.data.data) {
				object.$Message.info({
					content: res.data.data,
					duration: 5
				});
				if (callback) {
					callback(res.data.data);
				}
			} else {
				object.$Message.info("出错啦，稍后再试吧");
			}
		}
	} else if (isBusinessError(res)) {
		if (object) {
			if (res.data.data) {
				if (callback) {
					callback(res.data.data);
				}
			} else {

				object.$Message.info("出错啦，稍后再试吧");
			}
		}
	} else if (isForbidden(res)) {
		if (object) {
			if (res.data.data)
				object.$Message.info(res.data.data);
			else
				object.$router.push('403');
			// object.$Message.info("您没有权限访问该内容");
		}
	} else if (isBadRequest(res)) {
		if (object) {
			if (res.data.data) {
				object.$Message.info(res.data.data);
			} else if (res.data.status.message) {
				object.$Message.info(res.data.status.message);
			} else {
				object.$Message.info("参数错误，处理失败");
			}
		}
	} else if (isBadOrder(res)) {
		if (object) {
			if (res.data.data) {
				if (res.data.data === '用户已使用过餐标') {
					return "alreadyStandard";
				} else if (res.data.data === '获取用户区域失败') {
					return "areaChange";
				} else {
					object.$Message.info(res.data.data);
				}
			} else {
				object.$Message.info("对不起，暂时无法下单");
			}
			return 'bad_order';
		}
	} else if (isServerBusy(res)) {
		// console.log(res.data)
		object.$Message.info(res.data.status.message);
	}
	return false;
}



// WEBPACK FOOTER //
// ./src/util/response.js